import _ from 'lodash';
import { action, observable } from 'mobx';

/** system information that's hot, needs regular updating */
export class SystemStore {
  @observable stats: SystemInfo;
  @observable statStack: SystemInfo[] = [];
  maxLengthOfStack = 20;

  @action
  handleUpdateStats(stats: SystemInfo) {
    this.stats = stats;
    let newStack = _(this.statStack).clone();
    newStack.unshift(stats);
    if (newStack.length > this.maxLengthOfStack) {
      newStack = _(newStack)
        .initial()
        .value();
    }
    this.statStack = newStack;
  }
}

/** system information that shouldn't need to be updated that often */
export class AuxillarySystemStore {
  @observable cpu: CpuInfo;
  @observable network: NetworkInfo;
  @observable os: OSInfo;
  @observable gpu: GpusInfo;

  @action
  handleUpdateCpu(info: CpuInfo) {
    this.cpu = info;
  }

  @action
  handleUpdateNet(info: NetworkInfo) {
    this.network = info;
  }

  @action
  handleUpdateOS(info: OSInfo) {
    this.os = info;
  }

  @action
  handleUpdateGpu(info: GpusInfo) {
    this.gpu = info;
  }
}

/** neutered now; neither the username nor the avatar are actually shown anymore */
export class UserStore {
  @observable user: UserInfo;

  @action
  handleUpdateUser(user: UserInfo) {
    this.user = user;
  }
}

export const userStore = new UserStore();

export const systemStore = new SystemStore();

export const auxillarySystemStore = new AuxillarySystemStore();
